import useFetch from '../../../hooks/useFetch';
import chauffeurApi from '../chauffeurApi';

export default function useDissocierChauffeurApi() {
    return useFetch(chauffeurApi.dissocier);
}
